export const VENUE_META = {
  pumpfun: { name: "Pump.fun", chain: "Solana", color: "#FFC83B", explorer: "solscan.io" },
  stonkfun: { name: "StonkFun", chain: "Solana", color: "#10E396", explorer: "solscan.io" },
  fourmeme: { name: "Four.meme", chain: "BNB", color: "#F59E0B", explorer: "bscscan.com" },
  pons: { name: "Pons", chain: "Robinhood Chain", color: "#FF9D00", explorer: "ponscan.io" },
};

export const STATUS_META = {
  live: { label: "Live", cls: "bg-juice/15 text-juice border-juice/30" },
  draft: { label: "Draft", cls: "bg-dust/10 text-dust border-line" },
  paused: { label: "Paused", cls: "bg-warn/15 text-warn border-warn/30" },
  completed: { label: "Done", cls: "bg-pulp/15 text-pulp border-pulp/30" },
};

export const PLATFORM_META = {
  x: { label: "X", color: "#FAF6EE" },
  telegram: { label: "Telegram", color: "#FF9D00" },
  discord: { label: "Discord", color: "#FF9D00" },
  reddit: { label: "Reddit", color: "#FF4500" },
  tiktok: { label: "TikTok", color: "#25F4EE" },
  instagram: { label: "Instagram", color: "#E1306C" },
  youtube: { label: "YouTube", color: "#FF0000" },
};

export const KOL_SLOT_META = {
  offered: { label: "Offered", cls: "bg-dust/10 text-dust border-line" },
  accepted: { label: "Accepted", cls: "bg-ai/15 text-ai border-ai/30" },
  in_escrow: { label: "In escrow", cls: "bg-ai/15 text-ai border-ai/30" },
  proof_submitted: { label: "Proof in", cls: "bg-warn/15 text-warn border-warn/30" },
  released: { label: "Released", cls: "bg-pulp/15 text-pulp border-pulp/30" },
  disputed: { label: "Disputed", cls: "bg-danger/15 text-danger border-danger/30" },
  refunded: { label: "Refunded", cls: "bg-dust/10 text-dust border-line" },
  expired: { label: "Expired", cls: "bg-dust/10 text-dust border-line" },
  declined: { label: "Declined", cls: "bg-dust/10 text-dust border-line" },
  slashed_burn: { label: "Slashed→burn", cls: "bg-danger/15 text-danger border-danger/30" },
};

export const shortAddr = (a) => (a ? `${a.slice(0, 6)}…${a.slice(-4)}` : "—");
export const shortHash = (a) => (a ? `${a.slice(0, 8)}…${a.slice(-6)}` : "—");

export const timeAgo = (iso) => {
  const d = (Date.now() - new Date(iso).getTime()) / 1000;
  if (d < 60) return "just now";
  if (d < 3600) return `${Math.floor(d / 60)}m ago`;
  if (d < 86400) return `${Math.floor(d / 3600)}h ago`;
  return `${Math.floor(d / 86400)}d ago`;
};

export const HERO_IMG = "https://static.prod-images.emergentagent.com/jobs/4464994c-3b33-40a2-b73f-33af0393bb0c/images/d7fa22cca8d59bc767cdb0d70b8b141dfc46133c5f4eea57a9502a8ad7c471fb.jpeg";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const logoUrl = (logo) => {
  if (!logo) return null;
  const c = logo.cdn_512 || logo.cdn_256 || logo.cdn_1000;
  if (!c) return null;
  return c.startsWith("http") ? c : `${BACKEND}/api/files/${c}`;
};

export const DEST_META = {
  wallet: { label: "Connected wallet", color: "#FFC83B" },
  x: { label: "X handle", color: "#FAF6EE" },
  telegram: { label: "Telegram", color: "#FF9D00" },
};
